const MASK_CHAR = '*'
const MASK_LENGTH = 4
const MIN_VISIBLE_LOCAL_LENGTH = 3

/**
 * Masks an email address for privacy.
 * Reveals only the first two characters of the local part, replaces the rest with asterisks.
 * The domain is always shown in full.
 *
 * @example
 * maskEmail('jane.doe@example.com') // 'ja*****@example.com'
 * maskEmail('ab@example.com')       // '**@example.com'
 */
export function maskEmail(email: string): string {
  const atIndex = email.indexOf('@')

  if (atIndex === -1) {
    return MASK_CHAR.repeat(MASK_LENGTH)
  }

  const localPart = email.substring(0, atIndex)
  const domain = email.substring(atIndex)

  if (localPart.length < MIN_VISIBLE_LOCAL_LENGTH) {
    return `${MASK_CHAR.repeat(MASK_LENGTH)}${domain}`
  }

  const visible = localPart.substring(0, 2)
  return `${visible}${MASK_CHAR.repeat(MASK_LENGTH)}${domain}`
}
